import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading-multiple-request.component.html',
  styleUrls: ['./loading-multiple-request.component.sass'],
})
export class LoadingMultipleRequestComponent {}
